import './assets/style.css';
import 'vant/lib/index.css';

import { bootstrap } from '@/bootstrap.ts';
import { initWxInstance, useWx } from '@repo/wx';
import { getWxSignatureApi } from '@/api/wx';
import { isIOS, isWeixinBrowser } from '@repo/utils';
import { showConfirmDialog } from 'vant';

async function initApplication() {
  // ios 环境下wxConfig需要是第一次进入的url
  const url = location.href;

  const { wxConfig } = useWx();

  initWxInstance(getWxSignatureApi).then(() => {
    if (isIOS()) {
      wxConfig(url);
    }
  });

  if (isWeixinBrowser()) {
    history.pushState({ page: 'state1' }, 'state', '#state1');
    history.pushState({ page: 'state2' }, 'state', '#state2');

    window.addEventListener('popstate', function(e) {
      if (e.state?.page === 'state1') {
        showConfirmDialog({
          title: '提示',
          message: '是否要退出'
        })
          .then(() => {
            window.wx.closeWindow();
          })
          .catch(() => {
            history.pushState({ page: 'state1' }, 'state', '#state1');
          });
      }
    });
  }

  await bootstrap();
}

initApplication();
